const PRODUCT_LIST_EXPORT_PROMO_TYPES = [1, 2, 3, 4, 5, 6, 7, 8, 9];

const getProductRefcode = (product) => {
  const nestedProduct = product.product || {};

  return product.reference_code ||
    product.referenceCode ||
    product.refcode ||
    product.ref_code ||
    product.refCode ||
    nestedProduct.reference_code ||
    nestedProduct.referenceCode ||
    nestedProduct.refcode ||
    nestedProduct.ref_code ||
    nestedProduct.refCode ||
    (product.include_field === 'refcode' ? product.include_value : '') ||
    (product.include_field_ex === 'refcode' ? product.include_value_ex : '') ||
    '';
}

const setCsvHeaders = (promoType, rewardType, specialData) => {
  let csvHeaders = {
    name: { title: "Name" },
    barcode: { title: "Barcode" },
    refcode: { title: "Refcode" },
    retailPrice: { title: "Retail Price" },
    discount: { title: "Percent Discount" }
  }

  if (promoType == 1) {
    // Percent Discount (reward_type '1') keeps the base "Percent Discount"
    // title; other reward types relabel the discount column. Limit/Round are
    // applicable to all Type 1 reward types (see form: Limit input reward_type
    // ['1','2'], showMassLimit/showMassRound true for promo_type '1'), so they
    // must be present in the header for the export to include them.
    if (rewardType != '1') {
      const title = rewardType == '2' ? "Amount Discount" : "New Price";
      csvHeaders = { ...csvHeaders, discount: { title: title } }
    }
    csvHeaders = {
      ...csvHeaders,
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 2) {
    const discountTitle = rewardType == '1' || specialData.applyLevel != 'IL' ? "Multi-Level Discount" : "Percent Discount";
    const requiredTitle = rewardType == '2' ? "Minimum Amount" : "Required Quantity";
    if (rewardType != '1' && specialData.applyLevel == 'IL') {
      csvHeaders = { ...csvHeaders, requiredValue: { title: requiredTitle } }
    }

    csvHeaders = {
      ...csvHeaders,
      discount: { title: discountTitle },
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 3 && rewardType == '1') {
    delete csvHeaders["discount"];
    csvHeaders = {
      ...csvHeaders,
      requiredValue: { title: "Buy Qty" },
      discount: { title: "Take Qty" },
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 4) {
    delete csvHeaders["discount"];
    csvHeaders = {
      ...csvHeaders,
      limit: { title: "Limit" },
      round: { title: "Round" }
    }
  } else if (promoType == 5) {
    delete csvHeaders["discount"];
  } else if (promoType == 6 && rewardType == '2' && specialData.coupleType == '') {
    delete csvHeaders["discount"];
    csvHeaders = {
      ...csvHeaders,
      requiredValue: { title: "Quantity" },
      itemType: { title: "Item Type (P: Prerequisite, B: Bonus)" }
    }
  } else if ((promoType == 3 && rewardType == '2') ||
             (promoType == 6)) {
    delete csvHeaders["discount"];
    csvHeaders = { ...csvHeaders, requiredValue: { title: "Quantity" } }
  }

  return csvHeaders
}

const exportProduct = (promoType, rewardType, requiredProduct, rewardProducts=[], specialData={}) => {
  let csvData = [];

  // console.log(requiredProduct);
  // console.log(rewardProducts);

  if (PRODUCT_LIST_EXPORT_PROMO_TYPES.includes(promoType)) {
    requiredProduct.map(product => {
      let data = {
        name: product.name,
        barcode: product.barcode,
        refcode: getProductRefcode(product),
        retailPrice: product.retail_price,
        discount: product.promo_value,
        requiredValue: product.required_value,
        limit: product.max_application,
        round: product.round_to_nearest
      }

      if (promoType == 6 && rewardType == '2' && specialData.coupleType == '') {
        data.itemType = 'P'
      }

      csvData.push(data)
    })
  }

  if (promoType == 6 && rewardType == '2' && specialData.coupleType == '') {
    rewardProducts.map(product => {
      csvData.push({
        name: product.name,
        barcode: product.barcode,
        refcode: getProductRefcode(product),
        retailPrice: product.retail_price,
        discount: product.promo_value,
        requiredValue: product.required_value,
        limit: product.max_application,
        round: product.round_to_nearest,
        itemType: 'B'
      })
    })
  }

  return csvData;
}

const exportProductCSV = (promoType=0, rewardType="", requiredProduct=[], rewardProducts=[], specialData={}) => {
  const csvHeaders = setCsvHeaders(promoType, rewardType, specialData);
  const csvData = exportProduct(promoType, rewardType, requiredProduct, rewardProducts, specialData);

  return {
    csvHeaders,
    csvData
  }
}

export { exportProductCSV, PRODUCT_LIST_EXPORT_PROMO_TYPES }
